import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FileItem {
  id: string;
  name: string;
  size: number;
  createdAt: number;
  updatedAt: number;
  url?: string;
  folderId?: string;
  [key: string]: any;
}

export interface FolderItem {
  id: string;
  name: string;
  createdAt: number;
  updatedAt: number;
  parentId?: string;
  [key: string]: any;
}

export interface FileStorageState {
  files: FileItem[];
  folders: FolderItem[];
  initialized: boolean;
}

const initialState: FileStorageState = {
  files: [],
  folders: [],
  initialized: false,
};

const fileStorageSlice = createSlice({
  name: 'fileStorage',
  initialState,
  reducers: {
    setFiles(state, action: PayloadAction<FileItem[]>) {
      state.files = action.payload;
      state.initialized = true;
    },
    setFolders(state, action: PayloadAction<FolderItem[]>) {
      state.folders = action.payload;
      state.initialized = true;
    },
    addFile(state, action: PayloadAction<FileItem>) {
      state.files.push(action.payload);
    },
    updateFile(state, action: PayloadAction<FileItem>) {
      const idx = state.files.findIndex(f => f.id === action.payload.id);
      if (idx !== -1) state.files[idx] = action.payload;
    },
    removeFile(state, action: PayloadAction<string>) {
      state.files = state.files.filter(f => f.id !== action.payload);
    },
    addFolder(state, action: PayloadAction<FolderItem>) {
      state.folders.push(action.payload);
    },
    updateFolder(state, action: PayloadAction<FolderItem>) {
      const idx = state.folders.findIndex(f => f.id === action.payload.id);
      if (idx !== -1) state.folders[idx] = action.payload;
    },
    removeFolder(state, action: PayloadAction<string>) {
      state.folders = state.folders.filter(f => f.id !== action.payload);
    },
    resetFileStorage(state) {
      state.files = [];
      state.folders = [];
      state.initialized = false;
    },
  },
});

export const {
  setFiles,
  setFolders,
  addFile,
  updateFile,
  removeFile,
  addFolder,
  updateFolder,
  removeFolder,
  resetFileStorage,
} = fileStorageSlice.actions;

export default fileStorageSlice.reducer;
